<template>
  <transition name="pa-simple-fade" @before-enter="handleEnter">
    <div class="pa-tokei-modal-loading" v-if="isOpen">
      <div class="pa-tokei-modal-loading-content" ref="mainField">
        <p class="main">読み込み中...</p>
      </div>
      <div class="pa-tokei-modal-loading-overlay" ref="overlayField"></div>
    </div>
  </transition>
</template>

<script>
export default {
  props : {
    contentHeight : {
      default: 0,
    },

    isOpen     : {
      default: false
    }
  },

  watch : {
    contentHeight : {
      handler(){
        this.setContentHeight();
      },
      immediate: true
    },
  },

  methods : {
    setContentHeight(){
      if( (typeof this.$refs.mainField === 'undefined') || (this.$refs.mainField === null) ) return;
      if( (typeof this.$refs.overlayField === 'undefined') || (this.$refs.overlayField === null) ) return;
      
      this.$refs.mainField.style.height    = this.contentHeight + 'px';
      this.$refs.overlayField.style.height = this.contentHeight + 'px';
    },

    handleEnter(){
      this.setContentHeight();
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

@keyframes tokeiMesasgeLoading
{
  0%{
    color:#642941;
    opacity:0;
  }

  25%{
    color:#642941;
    opacity:.8;
  }

  50%{
    color: #77314E;
    opacity:.7;
  }

  75%{
    color:#642941;
    opacity:.8;
  }

  100%{
    color:#642941;
    opacity:0;
  }
}

.pa-tokei-modal-loading{
  &-content{
    position: absolute;
    z-index:11;
    top:0;
    left:0;
    width:100%;
    overflow: hidden;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p.main{
      text-align: center;
      font-size: 2rem;
      margin-top:-10rem;

      font-size:1.5rem;
      color:#77314e;
      animation: tokeiMesasgeLoading 5s infinite ease-in;
    }
  }

  &-overlay{
    position: absolute;
    z-index:10;
    top:0;
    left:0;
    width:100%;
    text-align: center;
    overflow: hidden;
    background:linear-gradient(0deg, rgba($body-background-primary, .55), rgba($body-background-semi-light-darker, .6));
    backdrop-filter: blur(3px) opacity(.5);
    box-sizing: border-box;
  }
}
</style>